
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#009AF6"}},[_c('path',{attrs:{"d":"M7.001 23.999a.5.5 0 01-.354-.147l-6.5-6.5a.5.5 0 01.708-.707l6.083 6.083L23.094.208a.503.503 0 01.697-.114c.109.078.18.193.202.325a.496.496 0 01-.087.373l-16.5 23a.501.501 0 01-.365.207h-.04z"}})])])
          )
        }
      }
    